import * as actionTypes from '../actions/actionTypes'

const initialState = {
  pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
  records: [],
  loading: false,
  success: false,
  filterLoading: false,
  selectedRecord: null,
  parent: [],
  company: [],
  level: [],
  filterCompany: [],
  imported: false,
  filterLevel: [],
  filterOrg: [],
  channel: [],
  province: [],
  forceRankGroup: [],
  loadingStates: [],
  gradeData: []
}

const fetchOrgStart = (state, action) => {
  return { ...state, loading: true, loadingStates: [...state.loadingStates, 'record'] }
}

const fetchOrgSuccess = (state, action) => {
  let { records } = action

  records = records.map(res => {
    let data = res
    return {
      ...data,
      company_name: data?.company?.company_name,
      level_name: data?.level?.level_name
    }
  })

  return {
    ...state,
    loading: false,
    pagination: action.pagination,
    loadingStates: state.loadingStates.filter(item => item !== 'record'),
    records
  }
}

const fetchOrgFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'record'),
    loading: false
  }
}

const fetchOrgByIdSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    selectedRecord: action.recordData,
    loadingStates: state.loadingStates.filter(item => item !== 'record')
  }
}

const clearSelectedOrgRecord = (state, action) => {
  return {
    ...state,
    selectedRecord: null,
    success: false
  }
}

const createOrgStart = (state, action) => {
  return { ...state, loading: true }
}

const createOrgSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const createOrgFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const updateOrgStart = (state, action) => {
  return { ...state, loading: true }
}

const updateOrgSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const updateOrgFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const deleteOrgStart = (state, action) => {
  return { ...state, loading: true }
}

const deleteOrgSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.message
  }
}

const deleteOrgFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchParentLevelStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchParentLevelSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    parent: action.data
  }
}

const fetchParentLevelFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchLevelStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchLevelSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    level: action.data
  }
}

const fetchLevelFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchCompanyStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchCompanySuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    company: action.data
  }
}

const fetchCompanyFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchOrgFilterCompanyStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchOrgFilterCompanySuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    filterCompany: action.data
  }
}

const fetchOrgFilterCompanyFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const fetchOrgFilterOrgStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchOrgFilterOrgSuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    filterOrg: action.data
  }
}

const fetchOrgFilterOrgFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const fetchOrgFilterLevelStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchOrgFilterLevelSuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    filterLevel: action.data
  }
}

const fetchOrgFilterLevelFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const importOrgStart = (state, action) => {
  return {
    ...state,
    importLoading: true,
    imported: false
  }
}

const importOrgSuccess = (state, action) => {
  return {
    ...state,
    importLoading: false,
    imported: true
  }
}

const importOrgFailed = (state, action) => {
  return {
    ...state,
    importLoading: false,
    imported: false
  }
}

const exportOrgStart = (state, action) => {
  return {
    ...state,
    loading: true
  }
}

const exportOrgSuccess = (state, action) => {
  return {
    ...state,
    loading: false
  }
}

const exportOrgFailed = (state, action) => {
  return {
    ...state,
    loading: false
  }
}

const downloadOrgTemplateStart = (state, action) => {
  return {
    ...state,
    loading: true
  }
}

const downloadOrgTemplateSuccess = (state, action) => {
  return {
    ...state,
    loading: false
  }
}

const downloadOrgTemplateFailed = (state, action) => {
  return {
    ...state,
    loading: false
  }
}

const fetchOrgOptionChannelStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchOrgOptionChannelSuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    channel: action.data
  }
}

const fetchOrgOptionChannelFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const fetchProvinceOptionStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchProvinceOptionSuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    province: action.data
  }
}

const fetchProvinceOptionFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const fetchForceRankGradeStart = (state, action) => {
  return {
    ...state
    // filtered: true
  }
}

const fetchForceRankGradeSuccess = (state, action) => {
  return {
    ...state,
    // filtered: true,
    gradeData: action.data
  }
}

const fetchForceRankGradeFailed = (state, action) => {
  return {
    ...state
    // filtered: false,
    // message: action.errorMessage
  }
}

const fetchForceRankGroupOptionStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchForceRankGroupOptionSuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    forceRankGroup: action.data
  }
}

const fetchForceRankGroupOptionFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ORGANIZATION_START:
      return fetchOrgStart(state, action)
    case actionTypes.FETCH_ORGANIZATION_SUCCESS:
      return fetchOrgSuccess(state, action)
    case actionTypes.FETCH_ORGANIZATION_BY_ID_SUCCESS:
      return fetchOrgByIdSuccess(state, action)
    case actionTypes.FETCH_ORGANIZATION_FAILED:
      return fetchOrgFailed(state, action)
    case actionTypes.CLEAR_SELECTED_ORGANIZATION_RECORD:
      return clearSelectedOrgRecord(state, action)
    case actionTypes.CREATE_ORGANIZATION_START:
      return createOrgStart(state, action)
    case actionTypes.CREATE_ORGANIZATION_SUCCESS:
      return createOrgSuccess(state, action)
    case actionTypes.CREATE_ORGANIZATION_FAILED:
      return createOrgFailed(state, action)
    case actionTypes.UPDATE_ORGANIZATION_START:
      return updateOrgStart(state, action)
    case actionTypes.UPDATE_ORGANIZATION_SUCCESS:
      return updateOrgSuccess(state, action)
    case actionTypes.UPDATE_ORGANIZATION_FAILED:
      return updateOrgFailed(state, action)
    case actionTypes.DELETE_ORGANIZATION_START:
      return deleteOrgStart(state, action)
    case actionTypes.DELETE_ORGANIZATION_SUCCESS:
      return deleteOrgSuccess(state, action)
    case actionTypes.DELETE_ORGANIZATION_FAILED:
      return deleteOrgFailed(state, action)
    case actionTypes.FETCH_ORGANIZATION_LEVEL_OPTIONS_START:
      return fetchLevelStart(state, action)
    case actionTypes.FETCH_ORGANIZATION_LEVEL_OPTIONS_SUCCESS:
      return fetchLevelSuccess(state, action)
    case actionTypes.FETCH_ORGANIZATION_LEVEL_OPTIONS_FAILED:
      return fetchLevelFailed(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_START:
      return fetchCompanyStart(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_SUCCESS:
      return fetchCompanySuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FAILED:
      return fetchCompanyFailed(state, action)
    case actionTypes.FETCH_PARENT_ORGANIZATION_LEVEL_OPTIONS_START:
      return fetchParentLevelStart(state, action)
    case actionTypes.FETCH_PARENT_ORGANIZATION_LEVEL_OPTIONS_SUCCESS:
      return fetchParentLevelSuccess(state, action)
    case actionTypes.FETCH_PARENT_ORGANIZATION_LEVEL_OPTIONS_FAILED:
      return fetchParentLevelFailed(state, action)
    case actionTypes.FETCH_ORGANIZATION_FILTER_COMPANY_START:
      return fetchOrgFilterCompanyStart(state, action)
    case actionTypes.FETCH_ORGANIZATION_FILTER_COMPANY_SUCCESS:
      return fetchOrgFilterCompanySuccess(state, action)
    case actionTypes.FETCH_ORGANIZATION_FILTER_COMPANY_FAILED:
      return fetchOrgFilterCompanyFailed(state, action)
    case actionTypes.FETCH_ORGANIZATION_FILTER_ORGANIZATION_START:
      return fetchOrgFilterOrgStart(state, action)
    case actionTypes.FETCH_ORGANIZATION_FILTER_ORGANIZATION_SUCCESS:
      return fetchOrgFilterOrgSuccess(state, action)
    case actionTypes.FETCH_ORGANIZATION_FILTER_ORGANIZATION_FAILED:
      return fetchOrgFilterOrgFailed(state, action)
    case actionTypes.FETCH_ORGANIZATION_FILTER_LEVEL_START:
      return fetchOrgFilterLevelStart(state, action)
    case actionTypes.FETCH_ORGANIZATION_FILTER_LEVEL_SUCCESS:
      return fetchOrgFilterLevelSuccess(state, action)
    case actionTypes.FETCH_ORGANIZATION_FILTER_LEVEL_FAILED:
      return fetchOrgFilterLevelFailed(state, action)
    case actionTypes.IMPORT_ORG_START:
      return importOrgStart(state, action)
    case actionTypes.IMPORT_ORG_SUCCESS:
      return importOrgSuccess(state, action)
    case actionTypes.IMPORT_ORG_FAILED:
      return importOrgFailed(state, action)
    case actionTypes.EXPORT_ORG_START:
      return exportOrgStart(state, action)
    case actionTypes.EXPORT_ORG_SUCCESS:
      return exportOrgSuccess(state, action)
    case actionTypes.EXPORT_ORG_FAILED:
      return exportOrgFailed(state, action)
    case actionTypes.DOWNLOAD_ORG_TEMPLATE_START:
      return downloadOrgTemplateStart(state, action)
    case actionTypes.DOWNLOAD_ORG_TEMPLATE_SUCCESS:
      return downloadOrgTemplateSuccess(state, action)
    case actionTypes.DOWNLOAD_ORG_TEMPLATE_FAILED:
      return downloadOrgTemplateFailed(state, action)
    case actionTypes.FETCH_ORGANIZATION_CHANNEL_OPTIONS_START:
      return fetchOrgOptionChannelStart(state, action)
    case actionTypes.FETCH_ORGANIZATION_CHANNEL_OPTIONS_SUCCESS:
      return fetchOrgOptionChannelSuccess(state, action)
    case actionTypes.FETCH_ORGANIZATION_CHANNEL_OPTIONS_FAILED:
      return fetchOrgOptionChannelFailed(state, action)
    case actionTypes.FETCH_PROVINCE_OPTIONS_START:
      return fetchProvinceOptionStart(state, action)
    case actionTypes.FETCH_PROVINCE_OPTIONS_SUCCESS:
      return fetchProvinceOptionSuccess(state, action)
    case actionTypes.FETCH_PROVINCE_OPTIONS_FAILED:
      return fetchProvinceOptionFailed(state, action)
    case actionTypes.FETCH_GRADE_OPTIONS_START:
      return fetchForceRankGradeStart(state, action)
    case actionTypes.FETCH_GRADE_OPTIONS_SUCCESS:
      return fetchForceRankGradeSuccess(state, action)
    case actionTypes.FETCH_GRADE_OPTIONS_FAILED:
      return fetchForceRankGradeFailed(state, action)
    case actionTypes.FETCH_FORCE_RANK_GROUP_FILTER_FORCE_RANK_GROUP_START:
      return fetchForceRankGroupOptionStart(state, action)
    case actionTypes.FETCH_FORCE_RANK_GROUP_FILTER_FORCE_RANK_GROUP_SUCCESS:
      return fetchForceRankGroupOptionSuccess(state, action)
    case actionTypes.FETCH_FORCE_RANK_GROUP_FILTER_FORCE_RANK_GROUP_FAILED:
      return fetchForceRankGroupOptionFailed(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
